import { useTranslation } from "react-i18next";
import SlotText from "../../invitation/SlotText";

// Text slots `momentsQuote`, `momentsSubtitle` and `momentsButton`.
const ExperienceCollectionQuote = ({ joinUrl }) => {
  const { t } = useTranslation();
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        width: "100%",
        marginTop: "80px",
      }}
    >
      <div
        style={{
          textAlign: "center",
          maxWidth: "920px",
          width: "100%",
          borderBottom: "1px solid #000",
          padding: "0px 20px 100px 20px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <div style={{ maxWidth: "700px", marginBottom: "60px" }}>
          <SlotText
            slot="momentsQuote"
            as="p"
            className="made-36"
            style={{ marginBottom: "30px" }}
          />
          <SlotText
            slot="momentsSubtitle"
            as="p"
            className="made-22"
            style={{ fontStyle: "italic", opacity: 0.8 }}
          />
        </div>

        <a
          href={joinUrl}
          className="button w-inline-block"
          target="_blank"
          rel="noopener noreferrer"
        >
          <div className="button-icon">
            <img
              src="/assets/photos/Button-Icon.svg"
              alt={t("home.gallery.iconAlt")}
              loading="lazy"
              className="b-icon"
            />
          </div>
          <SlotText slot="momentsButton" as="div" className="button-txt" />
        </a>
      </div>
      <div className="vert-line mbm-exclusion" style={{ height: "15vh" }}></div>
    </div>
  );
};

export default ExperienceCollectionQuote;
